<div class="header-containerr my-2 my-md-3">
    <div class="top-section d-flex flex-wrap-reverse align-items-start gap-2">
        <div
            class="top-left-section d-flex align-items-center column-gap-3 row-gap-2 order-1 flex-grow-1 flex-wrap flex-lg-nowrap">
            <div class="before-search" *ngIf="isVisible">
                <div class="select-wrapper d-flex align-items-end position-relative">
                    <div ngbDropdown class="custom-dropdown ps-0 ps-xl-3 dropdownTabs">
                        <button [disabled]="false" class="d-flex justify-content-between secondary-text" ngbDropdownToggle>
                            {{ currentSelection }}
                            <!-- <app-svg-icon class="align-items-center upIcon"
                                [src]="'./assets/SVGIcons/arrow-down-icon.svg'"></app-svg-icon> -->
                            <app-svg iconType="ArrowDown" class="align-items-center upIcon">
                            </app-svg>
                        </button>
                        <div class="intent custom-dropdown-menu" ngbDropdownMenu>
                            <div *ngIf="currentTab !== enumTabNames.SOURCING" class="dropdown-item hand  text-gray" (click)="setCurrentSelection('All', 'All')">All
                            </div>
                            <ng-container *ngIf="currentTab !== enumTabNames.REQUIREMENTS && currentTab !== enumTabNames.SOURCING">
                                <div class="dropdown-item hand  text-gray" *ngFor="let item of dropdownDataList"
                                    (click)="setCurrentSelection(item.name, item.id)" [hidden]="item.name == 'Vendor'">
                                    {{ item.name }}
                                </div>
                            </ng-container>
                            <ng-container *ngIf="currentTab == enumTabNames.REQUIREMENTS">
                                <div class="dropdown-item hand  text-gray"
                                    *ngFor="let item of getAllDropDownModel?.requirementStatusList"
                                    (click)="setCurrentSelection(item.name, item.id)">
                                    {{ item.name }}
                                </div>
                            </ng-container>
                            <ng-container *ngIf="currentTab == enumTabNames.SOURCING">
                                <div class="dropdown-item hand  text-gray"
                                    *ngFor="let item of statusOptions"
                                    (click)="sourcingStatusSelect(item)">
                                    {{ item.name }}
                                </div>
                            </ng-container>
                        </div>
                    </div>
                </div>
            </div>

            <!--*******Search Start*******-->
            <ng-container>
                <app-search-input
                    *ngIf="!route.includes(routerPath.PARTLISTINFO_ROUTEPATH) && !route.includes(routerPath.REQUIREMENTINFO_ROUTEPATH)"
                    [inputSearchPlaceholder]="getSearchPlaceholder()" class="d-flex align-items-end"
                    [ngClass]="{'ps-11':!isVisible, 'responsiveClass': currentTab == enumTabNames.PARTLIST }"
                    [inputSerachValue]="paginationBaseModel.searchText"
                    (inputSerachValueEmit)="searchTextFilter((paginationBaseModel.searchText = $event))">
                </app-search-input>
                <app-search-input
                    *ngIf="currentTab == this.enumTabNames.CONTACTS || currentTab == this.enumTabNames.VENDOR_CONTACT"
                    [inputSearchPlaceholder]="currentTab == this.enumTabNames.CONTACTS ? 'Search by company name…' : 'Search by vendor name...'"
                    class="d-flex align-items-end" [ngClass]="{ 'ps-0': !isVisible }"
                    [inputSerachValue]="paginationBaseModel.searchCompanyText"
                    (inputSerachValueEmit)="searchTextFilter((paginationBaseModel.searchCompanyText = $event))">
                </app-search-input>
            </ng-container>
            <!--*******Search End*******-->

            <!-- <div class="after-search d-flex"> -->
            <!--*******Part List Start*******-->
            <div *ngIf="currentTab == this.enumTabNames.PARTLIST" class="d-flex gap-3">
                <label class="text-gray secondary-text mb-0 d-flex align-items-center" for="">
                    Manufacturer:
                </label>
                <app-common-dropdown [data]="getAllPartDropdown?.masterManufacturerWithChildrenList"
                    [selectValue]="partListPaginationModel.mfrId"
                    (selectValueEmit)="partListPaginationModel.mfrId = $event;onSelectId($event)"></app-common-dropdown>
            </div>
            <app-checkbox class="ps-0 ps-md-3 pe-3 mt-1" *ngIf="currentTab == this.enumTabNames.PARTLIST"
                [lableClass]="'text-light-gray'"
                (check)="partListPaginationModel.isConsignment =!partListPaginationModel.isConsignment;onSelectId($event)"
                [status]="partListPaginationModel.isConsignment" [lableName]="'Show Consignment Only'"
                [dyanamicId]="'showConsignmentOnly'">
            </app-checkbox>
            <!--*******Part List End*******-->

            <!--*******Vendor Parts Library & OEM Excess Manager Start*******-->
            <ng-container *ngIf="route == routerPath.VENDOR_PARTS_LIBRARY || route == routerPath.OEM_EXCESS">
                <div class="col-12 col-sm-6 col-md-4 col-lg-3 ps-0 ps-md-2">
                    <ng-container *ngIf="route == routerPath.OEM_EXCESS ; else otherCondition">
                        <app-common-dropdown [dropdown]="true" [label]="'Customer:'" [id]="'Customer'"
                            [data]="getAllPartDropdown?.customerCompanyNameList"
                            [selectValue]="oemPaginationModel?.companyId"
                            (selectValueEmit)="oemPaginationModel.companyId = $event;onSelectId($event)">
                        </app-common-dropdown>
                    </ng-container>
                    <ng-template #otherCondition>
                        <app-common-dropdown [dropdown]="true" [label]="'Vendor:'" [id]="'Vendor'"
                            [data]="getAllPartDropdown?.vendorNameList" [selectValue]="vplPaginationModel?.vendorId"
                            (selectValueEmit)="vplPaginationModel.vendorId= $event;onSelectId($event)">
                        </app-common-dropdown>
                    </ng-template>
                </div>
                <div class="col-12 col-sm-6 col-md-4 col-lg-3 ps-0 ps-md-3">
                    <app-common-dropdown [dropdown]="true" [label]="'Manufacturer:'" [id]="'Manufacturer'"
                        [data]="getAllPartDropdown?.masterManufacturerWithChildrenList"
                        [selectValue]="route == routerPath.OEM_EXCESS? oemPaginationModel?.mfrId: vplPaginationModel?.mfrId"
                        (selectValueEmit)="route == routerPath.OEM_EXCESS? oemPaginationModel.mfrId = $event : vplPaginationModel.mfrId = $event;onSelectId($event)">
                    </app-common-dropdown>
                </div>
            </ng-container>
            <!--*******Vendor Parts Library & OEM Excess Manager End*******-->

            <!--*******Sourcing*******-->
            <ng-container *ngIf="currentTab == this.enumTabNames.SOURCING">
              <div class="d-flex gap-3">
                 <label class="text-gray secondary-text mb-0 d-flex align-items-center" for="">
                    Date Range
                </label>
                <app-custom-date-range-picker 
                  [inputDate]="sourceVendorFilter.dateRange"
                  (selectedDates)="onSourcingDateRangeSelected($event)" 
                  (emitDateClear)="onSourcingDateRangeSelected({})"
                  [inputLabel]="''"
                  [adjustStyleTab]="'sourcing'"
                  >
                </app-custom-date-range-picker>
              </div>
              <!-- <div class="d-flex gap-3">
                <label class="text-gray font-12 mb-0 d-flex align-items-center" for="">
                    Status
                </label>
                <app-common-dropdown
                 [selectValue]="sourcingStatus"
                 (selectValueEmit)="sourcingStatus = $event;sourceVendorEvent.emit({action : 'STATUS_CHANGE',data : sourcingStatus} )"
                 [data]="statusOptions">
                </app-common-dropdown>
              </div> -->
            </ng-container>
            <!--*******Sourcing & Send RFQs Tab End*******-->
            <!-- </div> -->

            <div class="filter d-flex gap-3" *ngIf="shouldShowFilterButton()">
                <app-button imgUrl="/assets/SVGIcons/Plus.svg" [buttonLable]="enumButtonName.FILTERS"
                    [buttonClass]="'border-theme'" [inputReadonly]="isButtonDisabled"
                    (click)="isLoading === false ? OpenFilterModal() : 0">
                </app-button>
                <div class="d-flex align-items-center clearFilters" (click)="clearAllFilter()"
                    *ngIf="selectFilterOptionlist.length > 0">
                    <!-- <app-svg-icon [src]="'./assets/SVGIcons/Clearicon.svg'" class="m-r-5 ">
                    </app-svg-icon> -->
                    <app-svg iconType="Clear" class="m-r-5 mt-1">
                    </app-svg>
                    <span class="text-nowrap clear-color font-13 m-t-2 clearFilter" type="button">
                        Clear Filters
                    </span>
                </div>
            </div>
            <div *ngIf="currentTab == this.enumTabNames.OUTLOOK" class="mx-2">
                    <app-checkbox class="select-All-activity" [lableClass]="'text-light-gray font-12'" [status]="selectAll" (check)="
                                 selectAll = !selectAll;outlookEvent.emit({type : 'SELECT_ALL', data : selectAll})" [lableName]="'Select All'">
                    </app-checkbox>
                </div>
        </div>
        <div
            class="top-right-section d-flex justify-content-end order-2 ms-auto flex-wrap {{route.includes(routerPath.PARTLISTINFO_ROUTEPATH) ? 'gap-0 gap-xl-2 align-items-end':'gap-2'}}">
            <ng-container *ngIf="currentTab != this.enumTabNames.COMPANY_RECYCLEBIN && currentTab != this.enumTabNames.CONTACT_RECYCLEBIN 
                            && currentTab != this.enumTabNames.ARCHIVEDCOMPANIES">
            
                <!--*******OUTLOOK BUTTON START*******-->
                
                <div *ngIf="countdownValue && currentTab == this.enumTabNames.OUTLOOK" class="m-auto">
                  <p class="text-center text-danger mb-0" >{{this.countdownValue | secondsToTime}}</p>
                 </div>
                <app-button *ngIf="currentTab == this.enumTabNames.OUTLOOK" imgUrl=""
                    [buttonLable]="enumButtonName.REFRESH" (click)="outlookEvent.emit({type :'REFRESH', data :null})">
                </app-button>
                <app-button *ngIf="currentTab == this.enumTabNames.OUTLOOK" imgUrl="" [buttonLable]="enumButtonName.DELETE"
                    (click)="outlookSelected.length ? outlookEvent.emit({type :'DELETE', data :null}) : null" [inputReadonly]="!outlookSelected.length"
                    [buttonClass]="outlookSelected.length ? 'border-red' : 'border-grey cursor-notAllowed '">
                </app-button>
                <app-button *ngIf="currentTab == this.enumTabNames.OUTLOOK" class="" imgUrl=""
                    [buttonLable]="'Mark as Read'" [inputReadonly]="!outlookSelected.length"
                    (click)="outlookSelected.length ? outlookEvent.emit({type :'MARK_READ_UNREAD', data :null}) : null" 
                    [buttonClass]="outlookSelected.length ? 'border-theme': 'border-grey cursor-notAllowed' ">
                </app-button>
                <app-button [ngbTooltip]="'Disconnect'" imgUrl="./assets/SVGIcons/shutdown.svg" *ngIf="currentTab == this.enumTabNames.OUTLOOK"
                    [buttonClass]="'border-red'" (iconClick)="outlookEvent.emit({type :'DISCONNECT', data :null})">
                </app-button>
                <!--*******OUTLOOK BUTTON END*******-->

                <!--*******NEW VENDOR OFFER BUTTON FOR TEMPORARY USE*******-->
                <app-button *ngIf="currentTab == enumTabNames.REQUIREMENTS" imgUrl=""
                    [buttonLable]="'Vendor Offer'" (click)="openVendorOffer()">
                </app-button>
                <app-button *ngIf="currentTab == this.enumTabNames.CONTACTS" imgUrl=""
                    [buttonLable]="enumButtonName.ADDCONTACT" (click)="openAddContactModal()">
                </app-button>

                <app-button *ngIf="shouldShowDefaultButton()" imgUrl="" [buttonLable]="buttonName"
                    (click)="currentTab !== enumTabNames.VENDOR_CONTACT ? openAddEditCompanyModal() : openAddContactModal()">
                </app-button>
                <app-button *ngIf="shouldShowTaskButton()" imgUrl="" [buttonLable]="enumButtonName.ADDTASK"
                    (click)="selectedData?.length != 0 ? open_AddTaskComponent() : ''"
                    [inputReadonly]="selectedData?.length == 0"
                    [buttonClass]="selectedData?.length != 0 ? 'border-theme' : 'border-grey cursor-notAllowed '">
                </app-button>

                <app-button *ngIf="shouldShowAssignButton()" imgUrl="" [buttonLable]="enumButtonName.ASSIGN"
                    (click)="openAssignModal()" [inputReadonly]="selectedData?.length == 0"
                    [buttonClass]="selectedData?.length != 0 ? 'border-theme' : 'border-grey cursor-notAllowed '">
                </app-button>

                <!--*******Delete Button Start*******-->
                <app-button *ngIf="shouldShowDeleteButton()" imgUrl="" [buttonLable]="enumButtonName.DELETE"
                    (click)="openDeleteModal()" [inputReadonly]="selectedData?.length == 0"
                    [buttonClass]="selectedData?.length != 0 ? 'border-red' : 'border-grey cursor-notAllowed '">
                </app-button>
                <!-- <app-button *ngIf="currentTab == this.enumTabNames.PARTLIST" class="" imgUrl=""
                    [buttonLable]="enumButtonName.DELETE" (click)="openDeletePartListModal()"
                    [inputReadonly]="selectedData?.length == 0"
                    [buttonClass]="selectedData?.length != 0 ? 'border-red' : 'border-grey cursor-notAllowed '">
                </app-button> -->
                <!--*******Delete Button End*******-->
                <app-button *ngIf="currentTab == this.enumTabNames.SOURCING"
                     imgUrl="" [buttonLable]="enumButtonName.ADD_OFFER" [buttonClass]="'border-theme'"
                       [buttonClass]="selectedData?.length === 1 ? 'border-theme' : 'border-grey cursor-notAllowed '"  
                     (click)="selectedData?.length === 1? addViewOfferForm() :  null">
                </app-button>
                <app-button
                    *ngIf="shouldShowArchieveButton()"
                    imgUrl="" buttonLable="Archive" (click)="selectedDataArchive()"
                    [inputReadonly]="selectedData?.length == 0"
                    [buttonClass]="selectedData?.length != 0 ? 'border-theme' : 'border-grey cursor-notAllowed '">
                </app-button>
                <app-button *ngIf=" currentTab == this.enumTabNames.COMPANIES" imgUrl="" buttonLable="Archive"
                    (click)="selectedDataArchive()" [inputReadonly]="selectedData?.length == 0"
                    [buttonClass]="selectedData?.length != 0 ? 'border-theme' : 'border-grey cursor-notAllowed '">
                </app-button>

                <!--*******Mailing button add start*******-->
                <app-button
                    *ngIf="currentTab == this.enumTabNames.COMPANIES || currentTab == this.enumTabNames.LEADS || currentTab == this.enumTabNames.PROSPECTS || currentTab == this.enumTabNames.CUSTOMERS"
                    imgUrl="" [buttonLable]="enumButtonName.ADDMAILINGLIST" (click)="openMailingListModal()"
                    [inputReadonly]="selectedData?.length == 0"
                    [buttonClass]="selectedData?.length != 0 ? 'border-theme' : 'border-grey cursor-notAllowed '">
                </app-button>
                <!--*******Mailing button add end*******-->

                <!--*******Send Mail Button Start*******-->
                <app-button
                    *ngIf="currentTab == this.enumTabNames.CONTACTS || currentTab == this.enumTabNames.VENDOR_CONTACT"
                    imgUrl="" [inputReadonly]="selectedData?.length == 0"
                    [buttonClass]="selectedData?.length != 0 ? 'border-theme' : 'border-grey cursor-notAllowed '"
                    [buttonLable]="enumButtonName.SENDEMAIL">
                </app-button>
                <!--*******Send Mail Button End*******-->

                <!--*******Requirements Button Start*******-->
                <ng-container
                    *ngIf="route == routerPath.REQUIREMENT_ROUTEPATH || route.includes(routerPath.REQUIREMENTINFO_ROUTEPATH)">
                    <ng-container *ngIf="route.includes(routerPath.REQUIREMENTINFO_ROUTEPATH); else showPartsAdd">
                        <app-button imgUrl="" [buttonLable]="'Add Requirement'" [buttonClass]="'border-theme' "
                            (click)="openAddRequiremnt('Add Requirement')">
                        </app-button>
                    </ng-container>
                    <ng-container *ngIf="isRequirementOptionShow">
                        <app-parts-button [name]="'Add'" marginClass="mx-0"  [optionWidth]="'110px'" [optionList]="requirementList"
                            [disabled]="false" (buttonOutputEvent)="onAddClick($event)">
                        </app-parts-button>
                    </ng-container>
                    <app-button imgUrl="" [buttonLable]="'Edit Requirement'"
                        [inputReadonly]="isRequirementRoute?false:(selectedData?.length !== 1)"
                        [buttonClass]="selectedData?.length === 1 || isRequirementRoute ? 'border-theme' : 'border-grey cursor-notAllowed '"
                        (click)="(selectedData?.length === 1 || isRequirementRoute) ? openAddRequiremnt('Edit Requirement') : ''">
                    </app-button>
                    <ng-container *ngIf="isRequirementOptionShow">
                        <app-button imgUrl="" [buttonLable]="'Clone Requirement'"
                            [inputReadonly]="isRequirementRoute?false:(selectedData?.length !== 1)"
                            [buttonClass]="selectedData?.length === 1 || isRequirementRoute ? 'border-theme' : 'border-grey cursor-notAllowed '"
                            (click)="(selectedData?.length === 1 || isRequirementRoute) ? onCloneReqClick('Add Requirement') : ''">
                        </app-button>
                    </ng-container>
                    <app-button imgUrl="" [buttonLable]="enumButtonName.SENDTOSOURCING"
                        [inputReadonly]="!selectedData?.length"
                        [ngClass]="{'cursor-notAllowed': !checkStatus}"
                        [buttonClass]=" checkStatus ? 'border-theme' : 'border-grey cursor-notAllowed '"
                        (click)="checkStatus  ? sendToSourcing() : null">
                    </app-button>
                    <ng-container *ngIf="isRequirementOptionShow">
                        <app-parts-button [name]="'Import'" [optionWidth]="'130px'" marginClass="mx-0"
                            [optionList]="importList" [disabled]="false" (buttonOutputEvent)="onImportClick($event)">
                        </app-parts-button>
                    </ng-container>
                    <ng-container *ngIf="route.includes(routerPath.REQUIREMENTINFO_ROUTEPATH)">
                        <app-button imgUrl="" [buttonLable]="enumButtonName.ADD_OFFER" [buttonClass]="'border-theme' "
                            (click)="addViewOfferForm()">
                        </app-button>
                    </ng-container>

                    <app-button [buttonClass]="isAddToQuoteEnable ? 'border-theme' : 'border-grey cursor-notAllowed'"
                        [buttonLable]="enumButtonName.ADDTOQUOTE"  [inputReadonly]="!isAddToQuoteEnable" (click)="isAddToQuoteEnable ? addToQuote() : null">
                    </app-button>
                </ng-container>
                <!--*******Requirements Button End*******-->

                <!--*******Parts List Start*******-->
                <app-button *ngIf="currentTab == this.enumTabNames.PARTLIST" class="" imgUrl=""
                    [buttonLable]="buttonName" [inputReadonly]="selectedData?.length > 0"
                    [buttonClass]="selectedData?.length == 0 ? 'border-theme': 'border-grey cursor-notAllowed' "
                    (click)="selectedData?.length > 0?'':openAddPartPopup('Add Part')">
                </app-button>
                 <div *ngIf="currentTab == this.enumTabNames.PARTLIST || route.includes(routerPath.PARTLISTINFO_ROUTEPATH)"
                    appClickOutside (clickOutside)="closeList()" class="d-flex position-relative">
                     <app-parts-button
                       [name]="'Import'" 
                       [optionWidth]="'130px'" 
                       marginClass="mx-0"
                       [optionList]="addiconList" 
                       [disabled]="false" 
                       (buttonOutputEvent)="seletedItem($event, false)">
                </app-parts-button>
                </div>
                <app-button *ngIf="route.includes(routerPath.PARTLISTINFO_ROUTEPATH)"
                    class=" {{route.includes(routerPath.PARTLISTINFO_ROUTEPATH)?'d-none d-xl-flex':''}}" imgUrl=""
                    [buttonLable]="buttonName" (click)="openAddPartPopup('Edit Part')">
                </app-button>

                <div *ngIf="currentTab == this.enumTabNames.PARTLIST || route.includes(routerPath.PARTLISTINFO_ROUTEPATH)"
                    appClickOutside (clickOutside)="closeNewList()" class="d-flex position-relative">
                    <app-button class=" {{route.includes(routerPath.PARTLISTINFO_ROUTEPATH)?'d-none d-xl-flex':''}}"
                        imgUrl="" [buttonLable]="enumButtonName.NEW"
                        [inputReadonly]="selectedData?.length == 0 && !route.includes(routerPath.PARTLISTINFO_ROUTEPATH)"
                        [buttonClass]="selectedData?.length == 1? 'border-theme'
                        : route.includes(routerPath.PARTLISTINFO_ROUTEPATH)? '': 'border-grey cursor-notAllowed' "
                        (click)="(selectedData?.length == 1 || route.includes(routerPath.PARTLISTINFO_ROUTEPATH)) ?showNewlist = !showNewlist:''">
                    </app-button>
                    <div class="list-wrap" style="width: 120px;" *ngIf="showNewlist">
                        <ol class="add-list-item" *ngFor="let listitem of addNewList; let i = index;let f=first">
                            <li><span (click)="seletedNewItem(i);">{{ listitem.name }}</span></li>
                        </ol>
                    </div>
                </div>
                <app-button
                    *ngIf="currentTab == this.enumTabNames.PARTLIST || route.includes(routerPath.PARTLISTINFO_ROUTEPATH)"
                    class="{{route.includes(routerPath.PARTLISTINFO_ROUTEPATH)?'d-none d-xl-flex':''}}" imgUrl=""
                    [buttonLable]="enumButtonName.CLONE"
                    [inputReadonly]="selectedData?.length == 0 && !route.includes(routerPath.PARTLISTINFO_ROUTEPATH)"
                    [buttonClass]="selectedData?.length == 1? 'border-theme'
                    : route.includes(routerPath.PARTLISTINFO_ROUTEPATH)? '': 'border-grey cursor-notAllowed'"
                    (click)="(selectedData?.length == 1  || route.includes(routerPath.PARTLISTINFO_ROUTEPATH)) ? openCloneAddPartPopup('Add Part'):''">
                </app-button>
                <app-button *ngIf="currentTab == this.enumTabNames.PARTLIST" class="" imgUrl=""
                    [buttonLable]="enumButtonName.DELETE" (click)="openDeletePartListModal()"
                    [inputReadonly]="selectedData?.length == 0"
                    [buttonClass]="selectedData?.length != 0 ? 'border-red' : 'border-grey cursor-notAllowed '">
                </app-button>
                <!--*******Parts List End*******-->

                <!--*******Vendor Parts Library & OEM Excess Manager*******-->
                <ng-container *ngIf="route == routerPath.VENDOR_PARTS_LIBRARY || route == routerPath.OEM_EXCESS">
                    <!-- <div appClickOutside class="d-flex gap-1 flex-wrap flex-sm-nowrap" (clickOutside)="closeList()"> -->
                    <app-button class="" *ngIf="route == routerPath.VENDOR_PARTS_LIBRARY" [buttonLable]="'VPL Update'"
                        [buttonClass]="'border-theme'" (click)="openRequestvendorpopup()">
                    </app-button>
                    <app-button class="" [buttonLable]="enumButtonName.DELETE"
                        [inputReadonly]="selectedData?.length == 0"
                        [buttonClass]="selectedData?.length != 0 ? 'border-red' : 'border-grey cursor-notAllowed '"
                        (click)="vplDeleteModal()">
                    </app-button>
                    <app-parts-button [name]="'Request'" marginClass="mx-0"
                        [optionList]="route == routerPath.OEM_EXCESS ? RequestList: vplRequestList"
                        [disabled]="selectedData?.length == 1?false:true"
                        [innerBtnClass]="selectedData?.length == 1?'':'border-grey cursor-notAllowed'"
                        (buttonOutputEvent)="onRequestClick($event)">
                    </app-parts-button>
                    <app-button class="" [buttonLable]="'Import'"
                        (click)="route == routerPath.VENDOR_PARTS_LIBRARY ? seletedItem({index: 3}, true):seletedItem({index: 2}, true)">
                    </app-button>
                    <app-parts-button [name]="'New'" [marginClass]="'mx-0'"
                        [optionList]="route == routerPath.OEM_EXCESS ? OemNewList : VplNewList"
                        (buttonOutputEvent)="buttonNewOutputEvent($event)">
                    </app-parts-button>
                    <app-parts-button [name]="'Line Status'" [marginClass]="'mx-0'"
                        [optionList]="route == routerPath.OEM_EXCESS ?  LineOEMExcessList : LineStatusList"
                        [disabled]="selectedData?.length == 0 ? true:false"
                        [innerBtnClass]="selectedData?.length == 0 ? 'border-grey cursor-notAllowed':''"
                        (buttonOutputEvent)="buttonLineStatusEvent($event)">
                    </app-parts-button>
                    <!-- </div> -->
                </ng-container>
                <!--*******Vendor Parts Library & OEM Excess Manager*******-->

                <!--*******Download Button*******-->
                <span class="download-icon onhover-dropdown b-r-8"
                    *ngIf="currentTab !== this.enumTabNames.PARTLIST && currentTab !== this.enumTabNames.OUTLOOK && !route.includes(routerPath.PARTLISTINFO_ROUTEPATH) && !route.includes(routerPath.PARTLISTINFO_ROUTEPATH) && currentTab !== this.enumTabNames.SOURCING">
                    <app-button [button_2]="true" [buttonClass]="'button button-primary'"
                        [buttonImageUrl]="'./assets/SVGIcons/downloadicon.svg'">
                    </app-button>
                    <ul class="onhover-show-div">
                        <li (click)="downloadPDF('pdf')" class="pb-1 font-14 text-gray text-nowrap">
                            Export as PDF
                        </li>
                        <li (click)="downLoadExcel()" class="font-14 text-gray text-nowrap">
                            Export as XLS
                        </li>
                    </ul>
                </span>
                <!--*******Download Button*******-->


                <!--*******Import Button*******-->
                <app-button *ngIf="shouldShowImportButton()" imgUrl="" [buttonLable]="buttonImport"
                    buttonClass="'border-theme'" (click)="navigateToImportCompnaies(buttonImport)">
                </app-button>
                <!--*******Import Button*******-->

                <!--*******RESPONSIVE IPAD PRO START*******-->
                <div *ngIf="route.includes(routerPath.PARTLISTINFO_ROUTEPATH)" class="d-flex d-xl-none ms-md-2 ms-sm-2 d-md-flex">
                    <div appClickOutside (clickOutside)="closeMenuList()" ngbDropdown class="threeDotIcon">
                        <img src="./assets/SVGIcons/threedot.svg" alt="" id="dropdownConfig" ngbDropdownToggle
                            width="35" height="35" />

                        <div ngbDropdownMenu aria-labelledby="dropdownConfig" style="color:#8B9DAA;font-weight: 600;">
                            <div class="position-relative">
                                <span (click)="showImportSubmenu = !showImportSubmenu "
                                    class="px-2 font-14 text-light-gray">Import</span>
                                <ng-template [ngIf]="showImportSubmenu">
                                    <ol class="dropdown-item "
                                        *ngFor="let listitem of addiconList; let i = index;let f=first">
                                        <li>
                                            <span (click)="seletedItem(i);"
                                                [ngClass]="{ activeName: listitem.selected}">{{
                                                listitem.name
                                                }}</span>
                                        </li>
                                    </ol>
                                </ng-template>
                            </div>
                            <span class="px-2 font-14 text-light-gray" (click)="openAddPartPopup('Edit Part')">Edit
                                Part</span>
                            <br>
                            <div class="position-relative">
                                <span (click)="showNewSubmenu = !showNewSubmenu"
                                    class="px-2 font-14 text-light-gray">New</span>
                                <ng-template [ngIf]="showNewSubmenu">
                                    <ol class="dropdown-item "
                                        *ngFor="let listitem of addNewList; let i = index;let f=first">
                                        <li><span (click)="seletedNewItem(i);">{{ listitem.name }}</span></li>
                                    </ol>
                                </ng-template>
                            </div>
                            <span class="px-2 font-14 text-light-gray"
                                (click)="(selectedData?.length == 1  || route.includes(routerPath.PARTLISTINFO_ROUTEPATH)) ? openCloneAddPartPopup('Add Part'):''">Clone</span><br>
                        </div>
                    </div>
                </div>
                <!--*******RESPONSIVE IPAD PRO END*******-->

                <!--*******Pin Button Start*******-->
                <!-- <app-svg-icon [src]="'./assets/SVGIcons/pin.svg'"
                    class="d-flex  {{currentTab == this.enumTabNames.PARTLIST || route == routerPath.VENDOR_PARTS_LIBRARY || route == routerPath.OEM_EXCESS? 'align-items-baseline':'align-items-center' }}"
                    (click)="pinned = !pinned; openFavouriteDockPopup(pinned)"
                    [ngClass]="pinned == true ? 'pinnedColor' : ''">
                </app-svg-icon> -->
                    <app-svg iconType="Pin" class="d-flex {{currentTab == this.enumTabNames.PARTLIST || route == routerPath.VENDOR_PARTS_LIBRARY || route == routerPath.OEM_EXCESS? 'align-items-baseline':'align-items-center' }}"
                      (click)="pinned = !pinned; openFavouriteDockPopup(pinned)"
                       [ngClass]="{
                            'pinnedColor': pinned === true,
                            'pin-icon-responsive': route.includes(routerPath.PARTLISTINFO_ROUTEPATH)
                        }">                        
                    </app-svg>
                <!--*******Pin Button End*******-->

            </ng-container>

            <!--*******Company-Recycle-Bin and Contact-Recycle-Bin Start*******-->
            <div *ngIf="currentTab == this.enumTabNames.COMPANY_RECYCLEBIN || currentTab == this.enumTabNames.CONTACT_RECYCLEBIN"
                class="company-header button-bar d-flex col-xl-6 col-md-12 col-lg-12 justify-content-end order-xl-2 order-lg-1 order-md-1">
                <div class="d-flex gap-2">
                    <app-button class="" imgUrl=""
                        [buttonClass]="selectedData?.length != 0 ? 'border-red' : 'border-grey cursor-notAllowed '"
                        (click)="restore(currentTab)" [buttonLable]="enumButtonName.RESTORE">
                    </app-button>
                    <app-button class="" imgUrl=""
                        [buttonClass]="selectedData?.length != 0 ? 'border-red' : 'border-grey cursor-notAllowed '"
                        [buttonLable]="enumButtonName.APPROVEDELETION"
                        (click)="approveDeletion(currentTab)"></app-button>
                </div>
            </div>
            <!--******Company-Recycle-Bin and Contact-Recycle-Bin End*******-->

            <!--******Archived Compainies start*******-->
            <div *ngIf="currentTab == this.enumTabNames.ARCHIVEDCOMPANIES"
                class="company-header button-bar d-flex col-xl-6 col-md-12 col-lg-12 justify-content-end order-xl-2 order-lg-1 order-md-1">
                <app-button class="" imgUrl="" [buttonLable]="'Unarchive'" [inputReadonly]="selectedData?.length == 0"
                    [buttonClass]="selectedData?.length != 0 ? 'border-theme' : 'border-grey cursor-notAllowed '"
                    (click)="Unarchive()">
                </app-button>
            </div>
            <!--******Archived Compainies end*******-->
        </div>
    </div>
    <div class="bottom-section filter-details d-flex mt-2 w-100" *ngIf="selectFilterOptionlist.length > 0">
        <div #fileterButton class="d-flex align-items-center filterBar row-gap-2 flex-grow-1 overflow-hidden"
            [ngClass]="{ 'flex-wrap': showFilter == selectFilterOptionlist.length }">
            <span #buttonRefs class="px-1"
                *ngFor=" let item of selectFilterOptionlist | slice : 0 : showFilter; let i = index">
                <app-button [ngbTooltip]="formatTooltipLabel(item.name == 'Class' ? 'Type' : item.labelName)"
                    placement="bottom-left" class="primary-bg" (iconClick)="removeFilterTab(item)"
                    imgUrl="/assets/SVGIcons/removeIcon.svg" [buttonLable]="item.name">
                </app-button>
            </span>
        </div>
        <span class="d-flex  align-items-center hand showOther end-0 flex-shrink-0" *ngIf="showFilter !== selectFilterOptionlist?.length &&
                 selectFilterOptionlist.length - showFilter > 0" (click)="showOther()">
            <span class="filter-btn mx-2 text-nowrap">
                +{{selectFilterOptionlist.length - showFilter ? selectFilterOptionlist.length - showFilter : 0 }}
                others
            </span>
        </span>
        <div class="flex-shrink-0" *ngIf="!isSideBarOpened || toggleFilter">
            <div *ngIf="selectFilterOptionlist.length - showFilter > 0 || toggleFilter" class="mt-1 py-2">
                <app-updown-arrow-toggle-button [isExpanded]="toggleFilter" (expandedChange)="seeAllorLess($event)">
                </app-updown-arrow-toggle-button>
            </div>
        </div>
    </div>

    <!-- <app-common-filter [items]="selectFilterOptionlist"></app-common-filter> -->
</div>